// import paymentOptions from './payment-mock.json';

export const BANK_ID_STATUS = {
    START: 'START',
    COMPLETE: 'COMPLETE',
    ERROR: 'ERROR'
};

export default () => {
    // const { paymentOptions: options } = paymentOptions;
    return {
        bankId: {
            open: false,
            status: BANK_ID_STATUS.START
        },
        buyerMember: null,
        checkoutSummary: null,
        hasError: false,
        items: null,
        isFetching: false,
        payment: {
            hasError: false,
            isFetching: false,
            paymentOptions: null,
            selectedPayment: 'Paynova'
        },
        selectedShipping: '',
        sellerMember: null,
        shippingOptions: null
    };
};
